// import { useState, useRef, useCallback, useEffect } from "react";
// import {
//   FaCrown,
//   FaNetworkWired,
//   FaBuilding,
//   FaBriefcase,
//   FaRocket,
//   FaEarthAmericas,
//   FaCheck,
//   FaXmark,
//   FaChevronLeft,
//   FaChevronRight,
//   FaStar,
//   FaArrowRight,
//   FaHand,
//   FaUsers,
//   FaAward,
//   FaCalendarDays,
//   FaShieldHalved,
//   FaChartLine,
//   FaLandmark,
//   FaBookOpen,
//   FaBullhorn,
//   FaCircleCheck,
// } from "react-icons/fa6";
// import { HiSparkles } from "react-icons/hi2";

// /* ────────────────────────────────────────────────── */
// /*   PLAN DATA                                       */
// /* ────────────────────────────────────────────────── */

// const growthIcon = <FaChartLine className="text-[13px]" />;
// const policyIcon = <FaLandmark className="text-[13px]" />;
// const knowledgeIcon = <FaBookOpen className="text-[13px]" />;
// const visibilityIcon = <FaBullhorn className="text-[13px]" />;

// const plans = [
//   {
//     id: "patron",
//     name: "Patron",
//     subtitle: "Ultimate Leadership",
//     icon: <FaCrown className="text-[28px]" />,
//     popular: true,
//     sections: [
//       {
//         title: "For Business Growth",
//         icon: growthIcon,
//         features: [
//           { label: "Managing Committee Membership", included: true },
//           { label: "Branding on ASSOCHAM Website", included: true },
//           { label: "Verified B2B Connects", included: true },
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Preferential Access to International Delegations & Engagements", included: true },
//           { label: "Business Networking through Events", included: true },
//           { label: "Opportunities for Industry–Industry Collaboration", included: true },
//           { label: "Access to National & Global Exhibitions", included: true },
//           { label: "Special Rates for Value-added Services", included: true },
//           { label: "Access to Co-Innovation with Startups", included: true },
//           { label: "Access to Funding & Investment Opportunities", included: true },
//         ],
//       },
//       {
//         title: "Policy Advocacy / Ease of Doing Business",
//         icon: policyIcon,
//         features: [
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Complimentary VISA Recommendation Letters", included: true },
//           { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
//           { label: "Access to Sector-specific Policy Consultations", included: true },
//           { label: "Regulatory and Policy Framework Inputs", included: true },
//           { label: "Advocacy at Central & State Government Levels", included: true },
//           { label: "Dedicated Membership Relationship Manager", included: true },
//           { label: "Representation of Industry Issues & Feedback", included: true },
//           { label: "Central & State Government Interface", included: true },
//           { label: "Alignment with National Missions & Initiatives", included: true },
//           { label: "Compliance & Government Relations Support", included: true },
//         ],
//       },
//       {
//         title: "Knowledge Hub",
//         icon: knowledgeIcon,
//         features: [
//           { label: "Regular Policy Update Notifications", included: true },
//           { label: "Access to ASSOCHAM Flagship Events", included: true },
//           { label: "Access to Members-Only Engagements", included: true },
//           { label: "Access to ASSOCHAM Knowledge Content", included: true },
//           { label: "Opportunity for Collaborative Publications", included: true },
//         ],
//       },
//       {
//         title: "Visibility & Outreach",
//         icon: visibilityIcon,
//         features: [
//           { label: "Logo on ASSOCHAM Website", included: true },
//           { label: "Recognition as an ASSOCHAM Managing Committee Member", included: true },
//           { label: "Preference for Council Leadership", included: true },
//           { label: "Preference for International Delegation Leadership", included: true },
//           { label: "Preference for Thought Leadership Platforms", included: true },
//           { label: "Visibility with Government Stakeholders", included: true },
//           { label: "Visibility with Industry Stakeholders", included: true },
//           { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
//           { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
//           { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
//         ],
//       },
//     ],
//   },
//   {
//     id: "associate",
//     name: "Associate",
//     subtitle: "Essential Access",
//     icon: <FaNetworkWired className="text-[28px]" />,
//     sections: [
//       {
//         title: "For Business Growth",
//         icon: growthIcon,
//         features: [
//           { label: "Managing Committee Membership", included: false },
//           { label: "Branding on ASSOCHAM Website", included: false },
//           { label: "Verified B2B Connects", included: true },
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Preferential Access to International Delegations & Engagements", included: true },
//           { label: "Business Networking through Events", included: true },
//           { label: "Opportunities for Industry–Industry Collaboration", included: true },
//           { label: "Access to National & Global Exhibitions", included: true },
//           { label: "Special Rates for Value-added Services", included: true },
//           { label: "Access to Co-Innovation with Startups", included: false },
//           { label: "Access to Funding & Investment Opportunities", included: false },
//         ],
//       },
//       {
//         title: "Policy Advocacy / Ease of Doing Business",
//         icon: policyIcon,
//         features: [
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
//           { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
//           { label: "Access to Sector-specific Policy Consultations", included: true },
//           { label: "Regulatory and Policy Framework Inputs", included: true },
//           { label: "Advocacy at Central & State Government Levels", included: true },
//           { label: "Dedicated Membership Relationship Manager", included: false },
//           { label: "Representation of Industry Issues & Feedback", included: true },
//           { label: "Central & State Government Interface", included: true },
//           { label: "Alignment with National Missions & Initiatives", included: true },
//           { label: "Compliance & Government Relations Support", included: true },
//         ],
//       },
//       {
//         title: "Knowledge Hub",
//         icon: knowledgeIcon,
//         features: [
//           { label: "Regular Policy Update Notifications", included: true },
//           { label: "Access to ASSOCHAM Flagship Events", included: true },
//           { label: "Access to Members-Only Engagements", included: true },
//           { label: "Access to ASSOCHAM Knowledge Content", included: true },
//           { label: "Opportunity for Collaborative Publications", included: true },
//         ],
//       },
//       {
//         title: "Visibility & Outreach",
//         icon: visibilityIcon,
//         features: [
//           { label: "Logo on ASSOCHAM Website", included: false },
//           { label: "Recognition as an ASSOCHAM Managing Committee Member", included: false },
//           { label: "Preference for Council Leadership", included: false },
//           { label: "Preference for International Delegation Leadership", included: false },
//           { label: "Preference for Thought Leadership Platforms", included: false },
//           { label: "Visibility with Government Stakeholders", included: true },
//           { label: "Visibility with Industry Stakeholders", included: true },
//           { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
//           { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
//           { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
//         ],
//       },
//     ],
//   },
//   {
//     id: "institutional",
//     name: "Institutional",
//     subtitle: "Enterprise Edge",
//     icon: <FaBuilding className="text-[28px]" />,
//     sections: [
//       {
//         title: "For Business Growth",
//         icon: growthIcon,
//         features: [
//           { label: "Managing Committee Membership", included: true },
//           { label: "Branding on ASSOCHAM Website", included: false },
//           { label: "Verified B2B Connects", included: true },
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Preferential Access to International Delegations & Engagements", included: true },
//           { label: "Business Networking through Events", included: true },
//           { label: "Opportunities for Industry–Industry Collaboration", included: true },
//           { label: "Access to National & Global Exhibitions", included: true },
//           { label: "Special Rates for Value-added Services", included: true },
//           { label: "Access to Co-Innovation with Startups", included: true },
//           { label: "Access to Funding & Investment Opportunities", included: false },
//         ],
//       },
//       {
//         title: "Policy Advocacy / Ease of Doing Business",
//         icon: policyIcon,
//         features: [
//           { label: "Participation in National & State Councils (4 Councils)", included: true },
//           { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
//           { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
//           { label: "Access to Sector-specific Policy Consultations", included: true },
//           { label: "Regulatory and Policy Framework Inputs", included: true },
//           { label: "Advocacy at Central & State Government Levels", included: true },
//           { label: "Dedicated Membership Relationship Manager", included: false },
//           { label: "Representation of Industry Issues & Feedback", included: true },
//           { label: "Central & State Government Interface", included: true },
//           { label: "Alignment with National Missions & Initiatives", included: true },
//           { label: "Compliance & Government Relations Support", included: true },
//         ],
//       },
//       {
//         title: "Knowledge Hub",
//         icon: knowledgeIcon,
//         features: [
//           { label: "Regular Policy Update Notifications", included: true },
//           { label: "Access to ASSOCHAM Flagship Events", included: true },
//           { label: "Access to Members-Only Engagements", included: true },
//           { label: "Access to ASSOCHAM Knowledge Content", included: true },
//           { label: "Opportunity for Collaborative Publications", included: true },
//         ],
//       },
//       {
//         title: "Visibility & Outreach",
//         icon: visibilityIcon,
//         features: [
//           { label: "Logo on ASSOCHAM Website", included: false },
//           { label: "Recognition as an ASSOCHAM Managing Committee Member", included: true },
//           { label: "Preference for Council Leadership", included: false },
//           { label: "Preference for International Delegation Leadership", included: false },
//           { label: "Preference for Thought Leadership Platforms", included: false },
//           { label: "Visibility with Government Stakeholders", included: true },
//           { label: "Visibility with Industry Stakeholders", included: true },
//           { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
//           { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
//           { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
//         ],
//       },
//     ],
//   },
//   {
//     id: "professional",
//     name: "Professional",
//     subtitle: "Individual Growth",
//     icon: <FaBriefcase className="text-[28px]" />,
//     sections: [
//       {
//         title: "For Business Growth",
//         icon: growthIcon,
//         features: [
//           { label: "Managing Committee Membership", included: false },
//           { label: "Branding on ASSOCHAM Website", included: false },
//           { label: "Verified B2B Connects", included: true },
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Preferential Access to International Delegations & Engagements", included: true },
//           { label: "Business Networking through Events", included: true },
//           { label: "Opportunities for Industry–Industry Collaboration", included: true },
//           { label: "Access to National & Global Exhibitions", included: true },
//           { label: "Special Rates for Value-added Services", included: true },
//           { label: "Access to Co-Innovation with Startups", included: false },
//           { label: "Access to Funding & Investment Opportunities", included: false },
//         ],
//       },
//       {
//         title: "Policy Advocacy / Ease of Doing Business",
//         icon: policyIcon,
//         features: [
//           { label: "Participation in National & State Councils (3 Councils)", included: true },
//           { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
//           { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
//           { label: "Access to Sector-specific Policy Consultations", included: true },
//           { label: "Regulatory and Policy Framework Inputs", included: true },
//           { label: "Advocacy at Central & State Government Levels", included: true },
//           { label: "Dedicated Membership Relationship Manager", included: false },
//           { label: "Representation of Industry Issues & Feedback", included: true },
//           { label: "Central & State Government Interface", included: true },
//           { label: "Alignment with National Missions & Initiatives", included: true },
//           { label: "Compliance & Government Relations Support", included: true },
//         ],
//       },
//       {
//         title: "Knowledge Hub",
//         icon: knowledgeIcon,
//         features: [
//           { label: "Regular Policy Update Notifications", included: true },
//           { label: "Access to ASSOCHAM Flagship Events", included: true },
//           { label: "Access to Members-Only Engagements", included: true },
//           { label: "Access to ASSOCHAM Knowledge Content", included: true },
//           { label: "Opportunity for Collaborative Publications", included: true },
//         ],
//       },
//       {
//         title: "Visibility & Outreach",
//         icon: visibilityIcon,
//         features: [
//           { label: "Logo on ASSOCHAM Website", included: false },
//           { label: "Recognition as an ASSOCHAM Managing Committee Member", included: false },
//           { label: "Preference for Council Leadership", included: false },
//           { label: "Preference for International Delegation Leadership", included: false },
//           { label: "Preference for Thought Leadership Platforms", included: false },
//           { label: "Visibility with Government Stakeholders", included: true },
//           { label: "Visibility with Industry Stakeholders", included: true },
//           { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
//           { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
//           { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
//         ],
//       },
//     ],
//   },
//   {
//     id: "startup",
//     name: "Start-Up",
//     subtitle: "Innovation Launchpad",
//     icon: <FaRocket className="text-[28px]" />,
//     sections: [
//       {
//         title: "For Business Growth",
//         icon: growthIcon,
//         features: [
//           { label: "Managing Committee Membership", included: true },
//           { label: "Branding on ASSOCHAM Website", included: false },
//           { label: "Verified B2B Connects", included: true },
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Preferential Access to International Delegations & Engagements", included: true },
//           { label: "Business Networking through Events", included: true },
//           { label: "Opportunities for Industry–Industry Collaboration", included: true },
//           { label: "Access to National & Global Exhibitions", included: true },
//           { label: "Special Rates for Value-added Services", included: true },
//           { label: "Access to Co-Innovation with Startups", included: false },
//           { label: "Access to Funding & Investment Opportunities", included: true },
//         ],
//       },
//       {
//         title: "Policy Advocacy / Ease of Doing Business",
//         icon: policyIcon,
//         features: [
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
//           { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
//           { label: "Access to Sector-specific Policy Consultations", included: true },
//           { label: "Regulatory and Policy Framework Inputs", included: true },
//           { label: "Advocacy at Central & State Government Levels", included: true },
//           { label: "Dedicated Membership Relationship Manager", included: false },
//           { label: "Representation of Industry Issues & Feedback", included: true },
//           { label: "Central & State Government Interface", included: true },
//           { label: "Alignment with National Missions & Initiatives", included: true },
//           { label: "Compliance & Government Relations Support", included: true },
//         ],
//       },
//       {
//         title: "Knowledge Hub",
//         icon: knowledgeIcon,
//         features: [
//           { label: "Regular Policy Update Notifications", included: true },
//           { label: "Access to ASSOCHAM Flagship Events", included: true },
//           { label: "Access to Members-Only Engagements", included: true },
//           { label: "Access to ASSOCHAM Knowledge Content", included: true },
//           { label: "Opportunity for Collaborative Publications", included: true },
//         ],
//       },
//       {
//         title: "Visibility & Outreach",
//         icon: visibilityIcon,
//         features: [
//           { label: "Logo on ASSOCHAM Website", included: false },
//           { label: "Recognition as an ASSOCHAM Managing Committee Member", included: false },
//           { label: "Preference for Council Leadership", included: false },
//           { label: "Preference for International Delegation Leadership", included: false },
//           { label: "Preference for Thought Leadership Platforms", included: false },
//           { label: "Visibility with Government Stakeholders", included: true },
//           { label: "Visibility with Industry Stakeholders", included: true },
//           { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
//           { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
//           { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
//         ],
//       },
//     ],
//   },
//   {
//     id: "international",
//     name: "International",
//     subtitle: "Global Connect",
//     icon: <FaEarthAmericas className="text-[28px]" />,
//     sections: [
//       {
//         title: "For Business Growth",
//         icon: growthIcon,
//         features: [
//           { label: "Managing Committee Membership", included: true },
//           { label: "Branding on ASSOCHAM Website", included: false },
//           { label: "Verified B2B Connects", included: true },
//           { label: "Participation in National & State Councils", included: true },
//           { label: "Preferential Access to International Delegations & Engagements", included: true },
//           { label: "Business Networking through Events", included: true },
//           { label: "Opportunities for Industry–Industry Collaboration", included: true },
//           { label: "Access to National & Global Exhibitions", included: true },
//           { label: "Special Rates for Value-added Services", included: true },
//           { label: "Access to Co-Innovation with Startups", included: false },
//           { label: "Access to Funding & Investment Opportunities", included: false },
//         ],
//       },
//       {
//         title: "Policy Advocacy / Ease of Doing Business",
//         icon: policyIcon,
//         features: [
//           { label: "Participation in National & State Councils (2 Councils)", included: true },
//           { label: "Complimentary VISA Recommendation Letters", included: false },
//           { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
//           { label: "Access to Sector-specific Policy Consultations", included: true },
//           { label: "Regulatory and Policy Framework Inputs", included: true },
//           { label: "Advocacy at Central & State Government Levels", included: false },
//           { label: "Dedicated Membership Relationship Manager", included: false },
//           { label: "Representation of Industry Issues & Feedback", included: true },
//           { label: "Central & State Government Interface", included: false },
//           { label: "Alignment with National Missions & Initiatives", included: true },
//           { label: "Compliance & Government Relations Support", included: true },
//         ],
//       },
//       {
//         title: "Knowledge Hub",
//         icon: knowledgeIcon,
//         features: [
//           { label: "Regular Policy Update Notifications", included: true },
//           { label: "Access to ASSOCHAM Flagship Events", included: true },
//           { label: "Access to Members-Only Engagements", included: true },
//           { label: "Access to ASSOCHAM Knowledge Content", included: true },
//           { label: "Opportunity for Collaborative Publications", included: true },
//         ],
//       },
//       {
//         title: "Visibility & Outreach",
//         icon: visibilityIcon,
//         features: [
//           { label: "Logo on ASSOCHAM Website", included: false },
//           { label: "Recognition as an ASSOCHAM Managing Committee Member", included: true },
//           { label: "Preference for Council Leadership", included: false },
//           { label: "Preference for International Delegation Leadership", included: false },
//           { label: "Preference for Thought Leadership Platforms", included: false },
//           { label: "Visibility with Government Stakeholders", included: true },
//           { label: "Visibility with Industry Stakeholders", included: true },
//           { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
//           { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
//           { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
//         ],
//       },
//     ],
//   },
// ];

// const avatarColors = ["#DA2128", "#F59C00", "#BE1B22", "#16a34a"];



// function Breadcrumb() {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
//     >
//       <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
//         <li>
//           <a
//             href="#top"
//             className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-4 w-4"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.2}
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </a>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li>
//           <a href="#/membership" className="transition-colors duration-300 hover:text-[#DA2128]">
//             Membership
//           </a>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">Membership Type</li>
//       </ol>
//     </nav>
//   );
// }

// /* ────────────────────────────────────────────────── */
// /*   COMPONENT                                       */
// /* ────────────────────────────────────────────────── */

// export default function MemberShipPlan() {
//   const [activeId, setActiveId] = useState("patron");
//   const [scrollPosition, setScrollPosition] = useState(0);
//   const [maxScroll, setMaxScroll] = useState(0);
//   const wrapperRef = useRef(null);
//   const dragRef = useRef({ isDown: false, startX: 0, scrollLeft: 0 });

//   const updateScrollState = useCallback(() => {
//     const el = wrapperRef.current;
//     if (!el) return;
//     setScrollPosition(el.scrollLeft);
//     setMaxScroll(el.scrollWidth - el.clientWidth);
//   }, []);

//   useEffect(() => {
//     updateScrollState();
//     const el = wrapperRef.current;
//     if (!el) return;
//     const onScroll = () => updateScrollState();
//     el.addEventListener("scroll", onScroll, { passive: true });
//     window.addEventListener("resize", updateScrollState);
//     return () => {
//       el.removeEventListener("scroll", onScroll);
//       window.removeEventListener("resize", updateScrollState);
//     };
//   }, [updateScrollState]);

//   const scrollByDir = (dir) => {
//     const el = wrapperRef.current;
//     if (!el) return;
//     el.scrollBy({
//       left: dir === "left" ? -el.clientWidth * 0.72 : el.clientWidth * 0.72,
//       behavior: "smooth",
//     });
//   };

//   const scrollToPlan = (id) => {
//     setActiveId(id);
//     const card = document.getElementById(`plan-${id}`);
//     card?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
//   };

//   const onPointerDown = (e) => {
//     const el = wrapperRef.current;
//     if (!el) return;
//     dragRef.current = { isDown: true, startX: e.clientX, scrollLeft: el.scrollLeft };
//     el.setPointerCapture(e.pointerId);
//   };

//   const onPointerMove = (e) => {
//     if (!dragRef.current.isDown || !wrapperRef.current) return;
//     wrapperRef.current.scrollLeft =
//       dragRef.current.scrollLeft - (e.clientX - dragRef.current.startX) * 1.6;
//   };

//   const onPointerUp = () => {
//     dragRef.current.isDown = false;
//   };

//   const isAtStart = scrollPosition <= 2;
//   const isAtEnd = scrollPosition >= maxScroll - 2;
//   const progress = maxScroll > 0 ? (scrollPosition / maxScroll) * 100 : 0;

//   return (
//     <div className="min-h-screen overflow-x-hidden bg-[#FBF9F4] font-sans text-[#1a1a1a] antialiased">
//       {/* ═══════════════ HERO ═══════════════ */}
//       <header className="relative overflow-hidden bg-gradient-to-b from-white via-[#FBF9F4] to-[#FBF9F4] px-5 pb-24 pt-14 text-center sm:pb-28 sm:pt-16">

//         <Breadcrumb />
//         {/* Soft floating orbs */}
//         <div className="pointer-events-none absolute -right-16 -top-20 h-80 w-80 animate-[floatY_5s_ease-in-out_infinite] rounded-full bg-[#fee7e4] opacity-55 blur-[60px]" />
//         <div className="pointer-events-none absolute -left-10 bottom-6 h-64 w-64 animate-[floatY_5s_ease-in-out_infinite_0.8s] rounded-full bg-[#fff3d6] opacity-55 blur-[60px]" />
//         <div className="pointer-events-none absolute left-[40%] top-[40%] h-44 w-44 animate-[floatY_5s_ease-in-out_infinite_1.6s] rounded-full bg-[#fee7e4] opacity-35 blur-[60px]" />

//         <div className="relative z-10 mx-auto max-w-3xl">
//           {/* Badge */}
//           <div className="mb-5 inline-flex animate-[fadeUp_0.7s_cubic-bezier(0.22,1,0.36,1)_both] items-center gap-2 rounded-full border border-[#f0ebe3] bg-white px-4 py-2 text-[13px] font-semibold text-[#DA2128] shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
//             <span className="h-2 w-2 animate-pulse rounded-full bg-green-500 shadow-[0_0_0_3px_rgba(22,163,74,0.18)]" />
//             <FaShieldHalved className="text-[14px]" />
//             Industry Trusted Since 1920
//           </div>

//           {/* Title */}
//           <h1 className="animate-[fadeUp_0.7s_cubic-bezier(0.22,1,0.36,1)_0.1s_both] text-[clamp(2rem,5vw,3.25rem)] font-extrabold leading-[1.15] tracking-tight">
//             ASSOCHAM{" "}
//             <span className="bg-gradient-to-br from-[#DA2128] via-[#BE1B22] to-[#F59C00] bg-clip-text text-transparent">
//               Membership Plans
//             </span>
//           </h1>

//           <p className="mx-auto mt-4 max-w-xl animate-[fadeUp_0.7s_cubic-bezier(0.22,1,0.36,1)_0.18s_both] text-[clamp(1rem,2.2vw,1.15rem)] leading-relaxed text-gray-600">
//             Compare benefits side-by-side and pick the plan that matches your business goals —
//             networking, policy advocacy, knowledge and brand visibility.
//           </p>

          
     
//         </div>
//       </header>

//       {/* ═══════════════ MAIN ═══════════════ */}
//       <main className="relative z-10 mx-auto -mt-9 max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
//         {/* Toolbar */}
//         <div className="mb-6 flex animate-[fadeUp_0.7s_cubic-bezier(0.22,1,0.36,1)_0.2s_both] flex-col items-center gap-4">
//           {/* Hint */}
//           <div className="inline-flex items-center gap-2.5 rounded-full border border-[#f0ebe3] bg-white px-5 py-2.5 text-[13px] font-medium text-gray-600 shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
//             <FaHand className="text-[14px] text-[#DA2128]" />
//             Drag or swipe to explore all <strong className="text-[#DA2128]">6</strong> plans
//             <HiSparkles className="text-[15px] text-[#DA2128]" />
//           </div>

//           {/* Tabs */}
//           {/* <div className="flex max-w-full flex-wrap justify-center gap-2">
//             {plans.map((plan) => {
//               const isActive = activeId === plan.id;
//               return (
//                 <button
//                   key={plan.id}
//                   type="button"
//                   onClick={() => scrollToPlan(plan.id)}
//                   className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-2 text-[13px] font-semibold shadow-[0_2px_8px_rgba(0,0,0,0.04)] transition-all duration-250 ${
//                     isActive
//                       ? "border-[#DA2128] bg-[#DA2128] text-white shadow-[0_8px_22px_rgba(218,33,40,0.22)]"
//                       : "border-[#f0ebe3] bg-white text-gray-600 hover:-translate-y-0.5 hover:border-[#f5c4c1] hover:bg-[#FEEFEC] hover:text-[#DA2128]"
//                   }`}
//                 >
//                   <span className="flex items-center justify-center text-[14px]">{plan.icon}</span>
//                   <span className="hidden sm:inline">{plan.name}</span>
//                 </button>
//               );
//             })}
//           </div> */}

//           {/* Progress bar */}
//           <div className="h-1 w-full max-w-xl overflow-hidden rounded-full bg-[#f3e8e6]">
//             <div
//               className="h-full rounded-full bg-gradient-to-r from-[#DA2128] via-[#F59C00] to-[#DA2128] bg-[length:200%_100%] transition-all duration-350 ease-out"
//               style={{ width: `${progress}%` }}
//             />
//           </div>
//         </div>

//         {/* ── Cards Scroll Area ── */}
//         <div
//           ref={wrapperRef}
//           onPointerDown={onPointerDown}
//           onPointerMove={onPointerMove}
//           onPointerUp={onPointerUp}
//           onPointerCancel={onPointerUp}
//           className="flex cursor-grab gap-5 overflow-x-auto pb-7 pt-3 select-none snap-x snap-mandatory [-webkit-overflow-scrolling:touch] [scrollbar-color:#DA2128_#f3e8e6] [scrollbar-width:thin] active:cursor-grabbing [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gradient-to-r [&::-webkit-scrollbar-thumb]:from-[#DA2128] [&::-webkit-scrollbar-thumb]:to-[#F59C00] [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-[#f3e8e6]"
//         >
//           {plans.map((plan, index) => {
//             const isActive = activeId === plan.id;
//             return (
//               <div
//                 key={plan.id}
//                 id={`plan-${plan.id}`}
//                 onClick={() => setActiveId(plan.id)}
//                 className="relative w-[min(348px,86vw)] shrink-0 snap-start animate-[cardIn_0.65s_cubic-bezier(0.22,1,0.36,1)_both]"
//                 style={{ animationDelay: `${index * 0.08}s` }}
//               >
//                 <article
//                   className={`relative flex h-full flex-col overflow-hidden rounded-[20px] border-[1.5px] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-all duration-350 ease-out hover:-translate-y-2 hover:border-[#f0c7c4] hover:shadow-[0_16px_50px_rgba(218,33,40,0.1)] ${
//                     isActive
//                       ? "-translate-y-1.5 border-[#DA2128] shadow-[0_18px_50px_rgba(218,33,40,0.14),0_0_0_4px_rgba(218,33,40,0.08)]"
//                       : "border-[#f0ebe3]"
//                   }`}
//                 >
//                   {/* Best Value badge */}
//                   {plan.popular && (
//                     <div className="absolute right-3.5 top-3.5 z-10 inline-flex items-center gap-1 rounded-full bg-gradient-to-br from-[#F59C00] to-[#E08F00] px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white shadow-[0_8px_30px_rgba(245,156,0,0.25)]">
//                       <FaStar className="text-[11px]" />
//                       Best Value
//                     </div>
//                   )}

//                   {/* Card Header */}
//                   <div
//                     className={`relative border-b border-[#f6efec] px-5 pb-5 pt-7 text-center ${
//                       isActive
//                         ? "bg-gradient-to-b from-[#fff0ee] to-white"
//                         : "bg-gradient-to-b from-[#fff9f8] to-white"
//                     }`}
//                   >
//                     {/* Icon box */}
//                     <div
//                       className={`mx-auto mb-3.5 flex h-16 w-16 items-center justify-center rounded-[18px] border transition-all duration-300 ${
//                         isActive
//                           ? "scale-105 border-transparent bg-gradient-to-br from-[#DA2128] to-[#BE1B22] text-white shadow-[0_10px_24px_rgba(218,33,40,0.14)]"
//                           : "border-[#f7d6d3] bg-gradient-to-br from-[#FEEFEC] to-white text-[#DA2128] shadow-[0_8px_20px_rgba(218,33,40,0.08)]"
//                       }`}
//                     >
//                       {plan.icon}
//                     </div>

//                     <h3 className="text-[1.45rem] font-extrabold tracking-tight text-[#1a1a1a]">
//                       {plan.name}
//                     </h3>
//                     <p className="mt-1.5 text-[13px] font-semibold tracking-wide text-gray-400">
//                       {plan.subtitle}
//                     </p>

//                     {/* Underline */}
//                     <div
//                       className={`mx-auto mt-3.5 h-[3px] rounded-full transition-all duration-300 ${
//                         isActive
//                           ? "w-16 bg-gradient-to-r from-[#DA2128] to-[#F59C00]"
//                           : "w-10 bg-[#f0d0cd]"
//                       }`}
//                     />
//                   </div>

//                   {/* Features Body */}
//                   <div className="flex flex-1 flex-col px-[18px] pb-[22px] pt-2">
//                     {plan.sections.map((section) => (
//                       <div key={section.title} className="mt-3.5">
//                         {/* Section title */}
//                         <h4
//                           className={`mb-2.5 flex items-center gap-2 rounded-[10px] px-3 py-2 text-[11px] font-extrabold uppercase tracking-wider ${
//                             isActive
//                               ? "border-l-[3px] border-[#F59C00] bg-[#FEEFEC] text-[#BE1B22]"
//                               : "border-l-[3px] border-[#f0c7c4] bg-[#faf7f2] text-[#BE1B22]"
//                           }`}
//                         >
//                           {section.icon}
//                           {section.title}
//                         </h4>

//                         {/* Features list */}
//                         <div className="space-y-0.5">
//                           {section.features.map((feature) => (
//                             <div
//                               key={feature.label}
//                               className="flex items-start gap-2.5 rounded-lg px-1.5 py-1.5 transition-colors duration-200 hover:bg-gray-50"
//                             >
//                               <span
//                                 className={`mt-0.5 flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full text-[11px] ${
//                                   feature.included
//                                     ? "bg-green-50 text-green-600"
//                                     : "bg-rose-50 text-rose-500"
//                                 }`}
//                               >
//                                 {feature.included ? <FaCheck /> : <FaXmark />}
//                               </span>
//                               <span
//                                 className={`text-[13.5px] leading-snug ${
//                                   feature.included ? "text-gray-600" : "text-gray-400"
//                                 }`}
//                               >
//                                 {feature.label}
//                               </span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     ))}

//                     {/* CTA Button */}
//                     <button
//                       type="button"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setActiveId(plan.id);
//                       }}
//                       className={`mt-[18px] flex w-full items-center justify-center gap-2 rounded-[14px] px-4 py-3.5 text-[13px] font-extrabold uppercase tracking-wider transition-all duration-250 active:scale-[0.98] ${
//                         isActive
//                           ? "bg-gradient-to-br from-[#F59C00] to-[#E08F00] text-white shadow-[0_8px_30px_rgba(245,156,0,0.25)] hover:-translate-y-0.5 hover:shadow-[0_12px_28px_rgba(245,156,0,0.35)]"
//                           : "border-[1.5px] border-[#f0c7c4] bg-white text-[#DA2128] hover:border-[#DA2128] hover:bg-[#FEEFEC]"
//                       }`}
//                     >
//                       {isActive ? (
//                         <>
//                           <FaCircleCheck className="text-[16px]" />
//                           Selected Plan
//                         </>
//                       ) : (
//                         <>
//                           Select {plan.name}
//                           <FaArrowRight className="text-[14px]" />
//                         </>
//                       )}
//                     </button>
//                   </div>
//                 </article>
//               </div>
//             );
//           })}
//         </div>

//         {/* ── Floating Arrows ── */}
//         {!isAtStart && (
//           <button
//             type="button"
//             onClick={() => scrollByDir("left")}
//             aria-label="Previous plans"
//             className="fixed left-4 top-1/2 z-40 hidden h-12 w-12 -translate-y-1/2 items-center justify-center rounded-2xl border border-[#f0ebe3] bg-white/90 text-[#DA2128] shadow-[0_10px_30px_rgba(0,0,0,0.08)] backdrop-blur-md transition-all duration-250 hover:scale-105 hover:bg-white hover:shadow-[0_12px_32px_rgba(218,33,40,0.15)] md:flex"
//           >
//             <FaChevronLeft className="text-[18px]" />
//           </button>
//         )}
//         {!isAtEnd && (
//           <button
//             type="button"
//             onClick={() => scrollByDir("right")}
//             aria-label="Next plans"
//             className="fixed right-4 top-1/2 z-40 hidden h-12 w-12 -translate-y-1/2 items-center justify-center rounded-2xl border border-[#f0ebe3] bg-white/90 text-[#DA2128] shadow-[0_10px_30px_rgba(0,0,0,0.08)] backdrop-blur-md transition-all duration-250 hover:scale-105 hover:bg-white hover:shadow-[0_12px_32px_rgba(218,33,40,0.15)] md:flex"
//           >
//             <FaChevronRight className="text-[18px]" />
//           </button>
//         )}

//       </main>

//       {/* Keyframe animations */}
//       <style>{`
//         @keyframes fadeUp {
//           from { opacity: 0; transform: translateY(28px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes floatY {
//           0%, 100% { transform: translateY(0); }
//           50%      { transform: translateY(-12px); }
//         }
//         @keyframes cardIn {
//           from { opacity: 0; transform: translateY(36px) scale(0.96); }
//           to   { opacity: 1; transform: translateY(0) scale(1); }
//         }
//       `}</style>
//     </div>
//   );
// }





// new code 



import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  Crown,
  Network,
  Building2,
  Briefcase,
  Rocket,
  Globe,
  Check,
  X,
  ChevronLeft,
  ChevronRight,
  ShieldCheck,
  TrendingUp,
  Landmark,
  BookOpen,
  Megaphone,
  Sparkles,
  ArrowRight,
  Hand,
  Home,
  ChevronRight as ChevronRightMini,
  LayoutGrid,
} from "lucide-react";

/* ────────────────────────────────────────────────── */
/* PLAN DATA                                        */
/* ────────────────────────────────────────────────── */

const growthIcon = <TrendingUp className="h-4 w-4 text-emerald-600 transition-transform duration-300 group-hover/sec:scale-110" />;
const policyIcon = <Landmark className="h-4 w-4 text-amber-600 transition-transform duration-300 group-hover/sec:scale-110" />;
const knowledgeIcon = <BookOpen className="h-4 w-4 text-blue-600 transition-transform duration-300 group-hover/sec:scale-110" />;
const visibilityIcon = <Megaphone className="h-4 w-4 text-rose-600 transition-transform duration-300 group-hover/sec:scale-110" />;

const plans = [
  {
    id: "patron",
    name: "Patron",
    subtitle: "Ultimate Leadership",
    icon: <Crown className="h-7 w-7 text-amber-500 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110" />,
    popular: true,
    accentColor: "from-amber-500/20 via-rose-500/10 to-transparent",
    badgeColor: "bg-amber-50 text-amber-700 border-amber-200/80",
    sections: [
      {
        title: "For Business Growth",
        icon: growthIcon,
        features: [
          { label: "Managing Committee Membership", included: true },
          { label: "Branding on ASSOCHAM Website", included: true },
          { label: "Verified B2B Connects", included: true },
          { label: "Participation in National & State Councils", included: true },
          { label: "Preferential Access to International Delegations & Engagements", included: true },
          { label: "Business Networking through Events", included: true },
          { label: "Opportunities for Industry–Industry Collaboration", included: true },
          { label: "Access to National & Global Exhibitions", included: true },
          { label: "Special Rates for Value-added Services", included: true },
          { label: "Access to Co-Innovation with Startups", included: true },
          { label: "Access to Funding & Investment Opportunities", included: true },
        ],
      },
      {
        title: "Policy Advocacy / Ease of Doing Business",
        icon: policyIcon,
        features: [
          { label: "Participation in National & State Councils", included: true },
          { label: "Complimentary VISA Recommendation Letters", included: true },
          { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
          { label: "Access to Sector-specific Policy Consultations", included: true },
          { label: "Regulatory and Policy Framework Inputs", included: true },
          { label: "Advocacy at Central & State Government Levels", included: true },
          { label: "Dedicated Membership Relationship Manager", included: true },
          { label: "Representation of Industry Issues & Feedback", included: true },
          { label: "Central & State Government Interface", included: true },
          { label: "Alignment with National Missions & Initiatives", included: true },
          { label: "Compliance & Government Relations Support", included: true },
        ],
      },
      {
        title: "Knowledge Hub",
        icon: knowledgeIcon,
        features: [
          { label: "Regular Policy Update Notifications", included: true },
          { label: "Access to ASSOCHAM Flagship Events", included: true },
          { label: "Access to Members-Only Engagements", included: true },
          { label: "Access to ASSOCHAM Knowledge Content", included: true },
          { label: "Opportunity for Collaborative Publications", included: true },
        ],
      },
      {
        title: "Visibility & Outreach",
        icon: visibilityIcon,
        features: [
          { label: "Logo on ASSOCHAM Website", included: true },
          { label: "Recognition as an ASSOCHAM Managing Committee Member", included: true },
          { label: "Preference for Council Leadership", included: true },
          { label: "Preference for International Delegation Leadership", included: true },
          { label: "Preference for Thought Leadership Platforms", included: true },
          { label: "Visibility with Government Stakeholders", included: true },
          { label: "Visibility with Industry Stakeholders", included: true },
          { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
          { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
          { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
        ],
      },
    ],
  },
  {
    id: "associate",
    name: "Associate",
    subtitle: "Essential Access",
    icon: <Network className="h-7 w-7 text-indigo-500 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110" />,
    accentColor: "from-indigo-500/20 via-blue-500/10 to-transparent",
    badgeColor: "bg-indigo-50 text-indigo-700 border-indigo-200/80",
    sections: [
      {
        title: "For Business Growth",
        icon: growthIcon,
        features: [
          { label: "Managing Committee Membership", included: false },
          { label: "Branding on ASSOCHAM Website", included: false },
          { label: "Verified B2B Connects", included: true },
          { label: "Participation in National & State Councils", included: true },
          { label: "Preferential Access to International Delegations & Engagements", included: true },
          { label: "Business Networking through Events", included: true },
          { label: "Opportunities for Industry–Industry Collaboration", included: true },
          { label: "Access to National & Global Exhibitions", included: true },
          { label: "Special Rates for Value-added Services", included: true },
          { label: "Access to Co-Innovation with Startups", included: false },
          { label: "Access to Funding & Investment Opportunities", included: false },
        ],
      },
      {
        title: "Policy Advocacy / Ease of Doing Business",
        icon: policyIcon,
        features: [
          { label: "Participation in National & State Councils", included: true },
          { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
          { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
          { label: "Access to Sector-specific Policy Consultations", included: true },
          { label: "Regulatory and Policy Framework Inputs", included: true },
          { label: "Advocacy at Central & State Government Levels", included: true },
          { label: "Dedicated Membership Relationship Manager", included: false },
          { label: "Representation of Industry Issues & Feedback", included: true },
          { label: "Central & State Government Interface", included: true },
          { label: "Alignment with National Missions & Initiatives", included: true },
          { label: "Compliance & Government Relations Support", included: true },
        ],
      },
      {
        title: "Knowledge Hub",
        icon: knowledgeIcon,
        features: [
          { label: "Regular Policy Update Notifications", included: true },
          { label: "Access to ASSOCHAM Flagship Events", included: true },
          { label: "Access to Members-Only Engagements", included: true },
          { label: "Access to ASSOCHAM Knowledge Content", included: true },
          { label: "Opportunity for Collaborative Publications", included: true },
        ],
      },
      {
        title: "Visibility & Outreach",
        icon: visibilityIcon,
        features: [
          { label: "Logo on ASSOCHAM Website", included: false },
          { label: "Recognition as an ASSOCHAM Managing Committee Member", included: false },
          { label: "Preference for Council Leadership", included: false },
          { label: "Preference for International Delegation Leadership", included: false },
          { label: "Preference for Thought Leadership Platforms", included: false },
          { label: "Visibility with Government Stakeholders", included: true },
          { label: "Visibility with Industry Stakeholders", included: true },
          { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
          { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
          { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
        ],
      },
    ],
  },
  {
    id: "institutional",
    name: "Institutional",
    subtitle: "Enterprise Edge",
    icon: <Building2 className="h-7 w-7 text-sky-500 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110" />,
    accentColor: "from-sky-500/20 via-indigo-500/10 to-transparent",
    badgeColor: "bg-sky-50 text-sky-700 border-sky-200/80",
    sections: [
      {
        title: "For Business Growth",
        icon: growthIcon,
        features: [
          { label: "Managing Committee Membership", included: true },
          { label: "Branding on ASSOCHAM Website", included: false },
          { label: "Verified B2B Connects", included: true },
          { label: "Participation in National & State Councils", included: true },
          { label: "Preferential Access to International Delegations & Engagements", included: true },
          { label: "Business Networking through Events", included: true },
          { label: "Opportunities for Industry–Industry Collaboration", included: true },
          { label: "Access to National & Global Exhibitions", included: true },
          { label: "Special Rates for Value-added Services", included: true },
          { label: "Access to Co-Innovation with Startups", included: true },
          { label: "Access to Funding & Investment Opportunities", included: false },
        ],
      },
      {
        title: "Policy Advocacy / Ease of Doing Business",
        icon: policyIcon,
        features: [
          { label: "Participation in National & State Councils (4 Councils)", included: true },
          { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
          { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
          { label: "Access to Sector-specific Policy Consultations", included: true },
          { label: "Regulatory and Policy Framework Inputs", included: true },
          { label: "Advocacy at Central & State Government Levels", included: true },
          { label: "Dedicated Membership Relationship Manager", included: false },
          { label: "Representation of Industry Issues & Feedback", included: true },
          { label: "Central & State Government Interface", included: true },
          { label: "Alignment with National Missions & Initiatives", included: true },
          { label: "Compliance & Government Relations Support", included: true },
        ],
      },
      {
        title: "Knowledge Hub",
        icon: knowledgeIcon,
        features: [
          { label: "Regular Policy Update Notifications", included: true },
          { label: "Access to ASSOCHAM Flagship Events", included: true },
          { label: "Access to Members-Only Engagements", included: true },
          { label: "Access to ASSOCHAM Knowledge Content", included: true },
          { label: "Opportunity for Collaborative Publications", included: true },
        ],
      },
      {
        title: "Visibility & Outreach",
        icon: visibilityIcon,
        features: [
          { label: "Logo on ASSOCHAM Website", included: false },
          { label: "Recognition as an ASSOCHAM Managing Committee Member", included: true },
          { label: "Preference for Council Leadership", included: false },
          { label: "Preference for International Delegation Leadership", included: false },
          { label: "Preference for Thought Leadership Platforms", included: false },
          { label: "Visibility with Government Stakeholders", included: true },
          { label: "Visibility with Industry Stakeholders", included: true },
          { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
          { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
          { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
        ],
      },
    ],
  },
  {
    id: "professional",
    name: "Professional",
    subtitle: "Individual Growth",
    icon: <Briefcase className="h-7 w-7 text-emerald-500 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110" />,
    accentColor: "from-emerald-500/20 via-teal-500/10 to-transparent",
    badgeColor: "bg-emerald-50 text-emerald-700 border-emerald-200/80",
    sections: [
      {
        title: "For Business Growth",
        icon: growthIcon,
        features: [
          { label: "Managing Committee Membership", included: false },
          { label: "Branding on ASSOCHAM Website", included: false },
          { label: "Verified B2B Connects", included: true },
          { label: "Participation in National & State Councils", included: true },
          { label: "Preferential Access to International Delegations & Engagements", included: true },
          { label: "Business Networking through Events", included: true },
          { label: "Opportunities for Industry–Industry Collaboration", included: true },
          { label: "Access to National & Global Exhibitions", included: true },
          { label: "Special Rates for Value-added Services", included: true },
          { label: "Access to Co-Innovation with Startups", included: false },
          { label: "Access to Funding & Investment Opportunities", included: false },
        ],
      },
      {
        title: "Policy Advocacy / Ease of Doing Business",
        icon: policyIcon,
        features: [
          { label: "Participation in National & State Councils (3 Councils)", included: true },
          { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
          { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
          { label: "Access to Sector-specific Policy Consultations", included: true },
          { label: "Regulatory and Policy Framework Inputs", included: true },
          { label: "Advocacy at Central & State Government Levels", included: true },
          { label: "Dedicated Membership Relationship Manager", included: false },
          { label: "Representation of Industry Issues & Feedback", included: true },
          { label: "Central & State Government Interface", included: true },
          { label: "Alignment with National Missions & Initiatives", included: true },
          { label: "Compliance & Government Relations Support", included: true },
        ],
      },
      {
        title: "Knowledge Hub",
        icon: knowledgeIcon,
        features: [
          { label: "Regular Policy Update Notifications", included: true },
          { label: "Access to ASSOCHAM Flagship Events", included: true },
          { label: "Access to Members-Only Engagements", included: true },
          { label: "Access to ASSOCHAM Knowledge Content", included: true },
          { label: "Opportunity for Collaborative Publications", included: true },
        ],
      },
      {
        title: "Visibility & Outreach",
        icon: visibilityIcon,
        features: [
          { label: "Logo on ASSOCHAM Website", included: false },
          { label: "Recognition as an ASSOCHAM Managing Committee Member", included: false },
          { label: "Preference for Council Leadership", included: false },
          { label: "Preference for International Delegation Leadership", included: false },
          { label: "Preference for Thought Leadership Platforms", included: false },
          { label: "Visibility with Government Stakeholders", included: true },
          { label: "Visibility with Industry Stakeholders", included: true },
          { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
          { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
          { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
        ],
      },
    ],
  },
  {
    id: "startup",
    name: "Start-Up",
    subtitle: "Innovation Launchpad",
    icon: <Rocket className="h-7 w-7 text-rose-500 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110" />,
    accentColor: "from-rose-500/20 via-orange-500/10 to-transparent",
    badgeColor: "bg-rose-50 text-rose-700 border-rose-200/80",
    sections: [
      {
        title: "For Business Growth",
        icon: growthIcon,
        features: [
          { label: "Managing Committee Membership", included: true },
          { label: "Branding on ASSOCHAM Website", included: false },
          { label: "Verified B2B Connects", included: true },
          { label: "Participation in National & State Councils", included: true },
          { label: "Preferential Access to International Delegations & Engagements", included: true },
          { label: "Business Networking through Events", included: true },
          { label: "Opportunities for Industry–Industry Collaboration", included: true },
          { label: "Access to National & Global Exhibitions", included: true },
          { label: "Special Rates for Value-added Services", included: true },
          { label: "Access to Co-Innovation with Startups", included: false },
          { label: "Access to Funding & Investment Opportunities", included: true },
        ],
      },
      {
        title: "Policy Advocacy / Ease of Doing Business",
        icon: policyIcon,
        features: [
          { label: "Participation in National & State Councils", included: true },
          { label: "Complimentary VISA Recommendation Letters (Paid service)", included: true },
          { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
          { label: "Access to Sector-specific Policy Consultations", included: true },
          { label: "Regulatory and Policy Framework Inputs", included: true },
          { label: "Advocacy at Central & State Government Levels", included: true },
          { label: "Dedicated Membership Relationship Manager", included: false },
          { label: "Representation of Industry Issues & Feedback", included: true },
          { label: "Central & State Government Interface", included: true },
          { label: "Alignment with National Missions & Initiatives", included: true },
          { label: "Compliance & Government Relations Support", included: true },
        ],
      },
      {
        title: "Knowledge Hub",
        icon: knowledgeIcon,
        features: [
          { label: "Regular Policy Update Notifications", included: true },
          { label: "Access to ASSOCHAM Flagship Events", included: true },
          { label: "Access to Members-Only Engagements", included: true },
          { label: "Access to ASSOCHAM Knowledge Content", included: true },
          { label: "Opportunity for Collaborative Publications", included: true },
        ],
      },
      {
        title: "Visibility & Outreach",
        icon: visibilityIcon,
        features: [
          { label: "Logo on ASSOCHAM Website", included: false },
          { label: "Recognition as an ASSOCHAM Managing Committee Member", included: false },
          { label: "Preference for Council Leadership", included: false },
          { label: "Preference for International Delegation Leadership", included: false },
          { label: "Preference for Thought Leadership Platforms", included: false },
          { label: "Visibility with Government Stakeholders", included: true },
          { label: "Visibility with Industry Stakeholders", included: true },
          { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
          { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
          { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
        ],
      },
    ],
  },
  {
    id: "international",
    name: "International",
    subtitle: "Global Connect",
    icon: <Globe className="h-7 w-7 text-teal-500 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110" />,
    accentColor: "from-teal-500/20 via-emerald-500/10 to-transparent",
    badgeColor: "bg-teal-50 text-teal-700 border-teal-200/80",
    sections: [
      {
        title: "For Business Growth",
        icon: growthIcon,
        features: [
          { label: "Managing Committee Membership", included: true },
          { label: "Branding on ASSOCHAM Website", included: false },
          { label: "Verified B2B Connects", included: true },
          { label: "Participation in National & State Councils", included: true },
          { label: "Preferential Access to International Delegations & Engagements", included: true },
          { label: "Business Networking through Events", included: true },
          { label: "Opportunities for Industry–Industry Collaboration", included: true },
          { label: "Access to National & Global Exhibitions", included: true },
          { label: "Special Rates for Value-added Services", included: true },
          { label: "Access to Co-Innovation with Startups", included: false },
          { label: "Access to Funding & Investment Opportunities", included: false },
        ],
      },
      {
        title: "Policy Advocacy / Ease of Doing Business",
        icon: policyIcon,
        features: [
          { label: "Participation in National & State Councils (2 Councils)", included: true },
          { label: "Complimentary VISA Recommendation Letters", included: false },
          { label: "Ministerial Delegations & Engagements with Senior Government Officials", included: true },
          { label: "Access to Sector-specific Policy Consultations", included: true },
          { label: "Regulatory and Policy Framework Inputs", included: true },
          { label: "Advocacy at Central & State Government Levels", included: false },
          { label: "Dedicated Membership Relationship Manager", included: false },
          { label: "Representation of Industry Issues & Feedback", included: true },
          { label: "Central & State Government Interface", included: false },
          { label: "Alignment with National Missions & Initiatives", included: true },
          { label: "Compliance & Government Relations Support", included: true },
        ],
      },
      {
        title: "Knowledge Hub",
        icon: knowledgeIcon,
        features: [
          { label: "Regular Policy Update Notifications", included: true },
          { label: "Access to ASSOCHAM Flagship Events", included: true },
          { label: "Access to Members-Only Engagements", included: true },
          { label: "Access to ASSOCHAM Knowledge Content", included: true },
          { label: "Opportunity for Collaborative Publications", included: true },
        ],
      },
      {
        title: "Visibility & Outreach",
        icon: visibilityIcon,
        features: [
          { label: "Logo on ASSOCHAM Website", included: false },
          { label: "Recognition as an ASSOCHAM Managing Committee Member", included: true },
          { label: "Preference for Council Leadership", included: false },
          { label: "Preference for International Delegation Leadership", included: false },
          { label: "Preference for Thought Leadership Platforms", included: false },
          { label: "Visibility with Government Stakeholders", included: true },
          { label: "Visibility with Industry Stakeholders", included: true },
          { label: "Listing in ASSOCHAM Directories (Sector-specific)", included: true },
          { label: "Select Brand Visibility through ASSOCHAM Social Media & Collaterals", included: true },
          { label: "Visibility through Exclusive Sponsorship Opportunities", included: true },
        ],
      },
    ],
  },
];

/* ────────────────────────────────────────────────── */
/* BREADCRUMB COMPONENT                             */
/* ────────────────────────────────────────────────── */

function Breadcrumb() {
  return (
    <nav aria-label="Breadcrumb" className="relative z-20 mb-8 inline-block">
      <ol className="flex items-center gap-2 rounded-full border border-slate-200/80 bg-white/80 px-4 py-1.5 text-xs font-medium text-slate-600 shadow-sm backdrop-blur-md">
        <li>
          <a href="#top" className="inline-flex items-center gap-1.5 transition-colors duration-200 hover:text-rose-600">
            <Home className="h-3.5 w-3.5" />
            Home
          </a>
        </li>
        <li className="text-slate-300">
          <ChevronRightMini className="h-3 w-3" />
        </li>
        <li>
          <a href="#/membership" className="transition-colors duration-200 hover:text-rose-600">
            Membership
          </a>
        </li>
        <li className="text-slate-300">
          <ChevronRightMini className="h-3 w-3" />
        </li>
        <li className="rounded-full bg-rose-50 px-2.5 py-0.5 text-xs font-medium text-rose-600 border border-rose-100">
          Membership Types
        </li>
      </ol>
    </nav>
  );
}

/* ────────────────────────────────────────────────── */
/* MAIN COMPONENT                                   */
/* ────────────────────────────────────────────────── */

export default function MemberShipPlan() {
  const [activeId, setActiveId] = useState("patron");
  const [scrollPosition, setScrollPosition] = useState(0);
  const [maxScroll, setMaxScroll] = useState(0);
  const wrapperRef = useRef(null);
  const dragRef = useRef({ isDown: false, startX: 0, scrollLeft: 0 });

  const updateScrollState = useCallback(() => {
    const el = wrapperRef.current;
    if (!el) return;
    setScrollPosition(el.scrollLeft);
    setMaxScroll(el.scrollWidth - el.clientWidth);
  }, []);

  useEffect(() => {
    updateScrollState();
    const el = wrapperRef.current;
    if (!el) return;
    const onScroll = () => updateScrollState();
    el.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", updateScrollState);
    return () => {
      el.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", updateScrollState);
    };
  }, [updateScrollState]);

  const scrollByDir = (dir) => {
    const el = wrapperRef.current;
    if (!el) return;
    const offset = dir === "left" ? -el.clientWidth * 0.75 : el.clientWidth * 0.75;
    el.scrollBy({ left: offset, behavior: "smooth" });
  };

  const scrollToPlan = (id) => {
    setActiveId(id);
    const card = document.getElementById(`plan-${id}`);
    card?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  };

  const onPointerDown = (e) => {
    const el = wrapperRef.current;
    if (!el) return;
    dragRef.current = { isDown: true, startX: e.clientX, scrollLeft: el.scrollLeft };
    el.setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e) => {
    if (!dragRef.current.isDown || !wrapperRef.current) return;
    wrapperRef.current.scrollLeft =
      dragRef.current.scrollLeft - (e.clientX - dragRef.current.startX) * 1.5;
  };

  const onPointerUp = () => {
    dragRef.current.isDown = false;
  };

  const isAtStart = scrollPosition <= 5;
  const isAtEnd = scrollPosition >= maxScroll - 5;
  const progress = maxScroll > 0 ? (scrollPosition / maxScroll) * 100 : 0;

  return (
    <div className="relative min-h-screen bg-slate-50/50 font-sans text-slate-800 antialiased">
      
      {/* ═══════════════ FLOATING SIDE NAVIGATION (LEFT & RIGHT) ═══════════════ */}
      
      {/* Floating Left Chevron Button */}
      <button
        type="button"
        onClick={() => scrollByDir("left")}
        disabled={isAtStart}
        aria-label="Scroll left to previous plan"
        className={`fixed left-4 top-1/2 z-50 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full border border-slate-200/90 bg-white/90 text-slate-700 shadow-xl backdrop-blur-md transition-all duration-300 hover:scale-110 hover:bg-rose-600 hover:text-white hover:border-rose-600 active:scale-95 disabled:opacity-0 disabled:pointer-events-none hidden md:flex`}
      >
        <ChevronLeft className="h-6 w-6" />
      </button>

      {/* Floating Right Chevron Button */}
      <button
        type="button"
        onClick={() => scrollByDir("right")}
        disabled={isAtEnd}
        aria-label="Scroll right to next plan"
        className={`fixed right-4 top-1/2 z-50 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full border border-slate-200/90 bg-white/90 text-slate-700 shadow-xl backdrop-blur-md transition-all duration-300 hover:scale-110 hover:bg-rose-600 hover:text-white hover:border-rose-600 active:scale-95 disabled:opacity-0 disabled:pointer-events-none hidden md:flex`}
      >
        <ChevronRight className="h-6 w-6" />
      </button>

      {/* Floating Right Indicator Quick Dock */}
      <div className="fixed right-6 top-1/2 z-40 -translate-y-1/2 hidden lg:flex flex-col gap-2 rounded-2xl border border-slate-200/80 bg-white/80 p-2 shadow-lg backdrop-blur-md">
        <div className="px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-slate-400 text-center border-b border-slate-100">
          Plans
        </div>
        {plans.map((plan) => {
          const isActive = activeId === plan.id;
          return (
            <button
              key={plan.id}
              onClick={() => scrollToPlan(plan.id)}
              title={plan.name}
              className={`group relative flex items-center justify-center h-9 w-9 rounded-xl transition-all duration-300 ${
                isActive
                  ? "bg-rose-600 text-white shadow-md shadow-rose-600/30 scale-105"
                  : "text-slate-500 hover:bg-slate-100 hover:text-slate-900"
              }`}
            >
              {React.cloneElement(plan.icon, { className: "h-4 w-4" })}
              {/* Tooltip on Hover */}
              <span className="absolute right-12 hidden rounded-md bg-slate-900 px-2 py-1 text-xs font-medium text-white shadow-md group-hover:block whitespace-nowrap">
                {plan.name}
              </span>
            </button>
          );
        })}
      </div>

      {/* ═══════════════ HERO HEADER ═══════════════ */}
      <header className="relative overflow-hidden bg-white border-b border-slate-100 px-4 pb-20 pt-10 text-center sm:px-6 sm:pb-24 sm:pt-14">
        <div className="pointer-events-none absolute left-1/2 top-0 -translate-x-1/2 h-96 w-full max-w-7xl bg-gradient-to-b from-rose-50/40 via-amber-50/20 to-transparent blur-3xl" />
        
        <div className="relative z-10 mx-auto max-w-4xl">
          <Breadcrumb />

          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-rose-100 bg-rose-50/60 px-3.5 py-1.5 text-xs font-medium text-rose-700 backdrop-blur-sm">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
            </span>
            <ShieldCheck className="h-4 w-4 text-rose-600" />
            Industry Trusted Since 1920
          </div>

          <h1 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            ASSOCHAM{" "}
            <span className="bg-gradient-to-r from-rose-600 via-amber-600 to-rose-600 bg-clip-text text-transparent">
              Membership Plans
            </span>
          </h1>

          <p className="mx-auto mt-4 max-w-2xl text-base text-slate-600 leading-relaxed font-normal">
            Compare key features side-by-side and select the ideal plan for your organizational growth, policy advocacy, knowledge access, and brand visibility.
          </p>

          {/* Quick Nav Pills */}
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {plans.map((plan) => {
              const isActive = activeId === plan.id;
              return (
                <button
                  key={plan.id}
                  type="button"
                  onClick={() => scrollToPlan(plan.id)}
                  className={`group inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-medium transition-all duration-300 ${
                    isActive
                      ? "border-rose-600 bg-rose-600 text-white shadow-sm shadow-rose-600/20"
                      : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900"
                  }`}
                >
                  <span className={`transition-transform duration-300 ${isActive ? "scale-110" : "group-hover:scale-110"}`}>
                    {React.cloneElement(plan.icon, { className: "h-3.5 w-3.5" })}
                  </span>
                  {plan.name}
                </button>
              );
            })}
          </div>
        </div>
      </header>

      {/* ═══════════════ MAIN CONTENT ═══════════════ */}
      <main className="relative z-10 mx-auto -mt-8 max-w-7xl px-4 pb-20 sm:px-6 lg:px-8">
        {/* Interaction Header Bar */}
        <div className="mb-6 flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
          <div className="inline-flex items-center gap-2 rounded-full border border-slate-200/80 bg-white/90 px-4 py-1.5 text-xs font-medium text-slate-500 shadow-sm backdrop-blur-md">
            <Hand className="h-3.5 w-3.5 text-rose-500 animate-pulse" />
            <span>Swipe, drag or use floating side arrows to explore</span>
            <Sparkles className="h-3.5 w-3.5 text-amber-500" />
          </div>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5">
              <button
                type="button"
                onClick={() => scrollByDir("left")}
                disabled={isAtStart}
                aria-label="Previous plan"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm transition-all hover:bg-slate-50 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
              >
                <ChevronLeft className="h-4 w-4" />
              </button>
              <button
                type="button"
                onClick={() => scrollByDir("right")}
                disabled={isAtEnd}
                aria-label="Next plan"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm transition-all hover:bg-slate-50 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
              >
                <ChevronRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Dynamic Scroll Progress Bar */}
        <div className="mb-8 h-1.5 w-full overflow-hidden rounded-full bg-slate-200/60">
          <div
            className="h-full rounded-full bg-gradient-to-r from-rose-500 via-amber-500 to-rose-500 transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* ── Cards Scroll Container ── */}
        <div
          ref={wrapperRef}
          onPointerDown={onPointerDown}
          onPointerMove={onPointerMove}
          onPointerUp={onPointerUp}
          onPointerCancel={onPointerUp}
          className="flex cursor-grab select-none gap-6 overflow-x-auto pb-8 pt-2 snap-x snap-mandatory scrollbar-none active:cursor-grabbing"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {plans.map((plan) => {
            const isSelected = activeId === plan.id;

            return (
              <div
                key={plan.id}
                id={`plan-${plan.id}`}
                onClick={() => setActiveId(plan.id)}
                className={`group relative flex w-[310px] sm:w-[350px] shrink-0 snap-center flex-col rounded-2xl border bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${
                  isSelected
                    ? "border-rose-500/80 ring-2 ring-rose-500/20"
                    : "border-slate-200/80 hover:border-slate-300"
                }`}
              >
                {/* Popular Badge */}
                {plan.popular && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <span className="inline-flex items-center gap-1 rounded-full bg-rose-600 px-3 py-0.5 text-[11px] font-medium tracking-wide text-white shadow-sm">
                      <Sparkles className="h-3 w-3" /> Most Popular
                    </span>
                  </div>
                )}

                {/* Top Subtle Gradient */}
                <div className={`absolute inset-x-0 top-0 h-24 rounded-t-2xl bg-gradient-to-b ${plan.accentColor} pointer-events-none`} />

                {/* Card Header */}
                <div className="relative z-10 mb-6 border-b border-slate-100 pb-5">
                  <div className="flex items-start justify-between gap-3">
                    <div className="rounded-xl border border-slate-100 bg-white p-2.5 shadow-sm">
                      {plan.icon}
                    </div>
                    <span className={`rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${plan.badgeColor}`}>
                      {plan.subtitle}
                    </span>
                  </div>

                  <h3 className="mt-4 text-xl font-semibold text-slate-900">
                    {plan.name}
                  </h3>
                </div>

                {/* Features Section */}
                <div className="relative z-10 flex-1 space-y-6">
                  {plan.sections.map((sec, idx) => (
                    <div key={idx} className="group/sec space-y-2.5">
                      <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
                        {sec.icon}
                        <span>{sec.title}</span>
                      </div>

                      <ul className="space-y-2 pl-1">
                        {sec.features.map((feat, fIdx) => (
                          <li key={fIdx} className="flex items-start gap-2.5 text-xs text-slate-600 leading-snug">
                            {feat.included ? (
                              <Check className="h-3.5 w-3.5 shrink-0 text-emerald-600 mt-0.5" />
                            ) : (
                              <X className="h-3.5 w-3.5 shrink-0 text-slate-300 mt-0.5" />
                            )}
                            <span className={feat.included ? "text-slate-700" : "text-slate-400 line-through decoration-slate-300"}>
                              {feat.label}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                {/* Action CTA */}
                <div className="relative z-10 mt-8 pt-4 border-t border-slate-100">
                  {/* <button
                    type="button"
                    className={`w-full inline-flex items-center justify-center gap-2 rounded-xl py-2.5 px-4 text-xs font-medium transition-all duration-200 active:scale-[0.98] ${
                      isSelected
                        ? "bg-rose-600 text-white shadow-sm hover:bg-rose-700 shadow-rose-600/20"
                        : "bg-slate-100 text-slate-700 hover:bg-slate-200 hover:text-slate-900"
                    }`}
                  >
                    <span>Select {plan.name} Plan</span>
                    <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                  </button> */}
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}